import { render, staticRenderFns } from "./FooterDefault.vue?vue&type=template&id=508f85dc&scoped=true"
import script from "./FooterDefault.vue?vue&type=script&lang=js"
export * from "./FooterDefault.vue?vue&type=script&lang=js"
import style0 from "./FooterDefault.vue?vue&type=style&index=0&id=508f85dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f85dc",
  null
  
)

export default component.exports